import { useCallback, useState } from 'react';
import * as React from 'react';

import ModalBase, { ModalBaseProps } from '@/components/layouts/Modal/Base';
import Cc3D2Auth, {
  Cc3D2AuthProps,
} from '@/components/layouts/Modal/Order/Cc3D2Auth';
import { QuickChargeStep } from '@/components/layouts/Modal/Order/QuickCharge';
import QuickChargeFailure from '@/components/layouts/Modal/Order/QuickCharge/Failure';
import QuickChargeTimeout from '@/components/layouts/Modal/Order/QuickCharge/Timeout';
import { ChargeType } from '@/modelTypes';

import { Title } from './style';

export interface Cc3D2AuthChargeStep {
  chargeStep: QuickChargeStep;
}

interface Cc3D2AuthModalProps
  extends ModalBaseProps,
    Cc3D2AuthProps,
    Cc3D2AuthChargeStep {}

const Cc3D2AuthModalContent: React.FC<Cc3D2AuthModalProps> = ({
  handleClose,
  authResponse,
  onSuccess,
  onFailure,
  onTimeout,
}) => {
  const [isFailed, setIsFailed] = useState<boolean>(false);

  const handleFailed = useCallback(() => {
    setIsFailed(true);
    onFailure();
  }, []);

  if (isFailed) {
    return (
      <QuickChargeFailure
        chargeType={ChargeType.Credit}
        handleClose={handleClose}
      />
    );
  }

  return (
    <Cc3D2Auth
      authResponse={authResponse}
      onSuccess={onSuccess}
      onFailure={handleFailed}
      onTimeout={onTimeout}
    />
  );
};

const Cc3D2AuthModal: React.FC<Cc3D2AuthModalProps> = props => {
  const { isOpen, handleClose } = props;

  return (
    <>
      <ModalBase isOpen={isOpen} handleClose={handleClose} mobileWidth="100%">
        <Title>
          toreta+ チャージ
          {props.chargeStep === QuickChargeStep.InProgress && '（処理中...）'}
          {props.chargeStep === QuickChargeStep.Timeout && '（タイムアウト）'}
        </Title>
        {props.chargeStep !== QuickChargeStep.Timeout && (
          <Cc3D2AuthModalContent
            handleClose={props.handleClose}
            isOpen={props.isOpen}
            authResponse={props.authResponse}
            onSuccess={props.onSuccess}
            onFailure={props.onFailure}
            onTimeout={props.onTimeout}
            chargeStep={props.chargeStep}
          />
        )}
        {props.chargeStep === QuickChargeStep.Timeout && (
          <QuickChargeTimeout
            chargeType={ChargeType.Credit}
            handleClose={() => handleClose()}
          />
        )}
      </ModalBase>
    </>
  );
};

export default Cc3D2AuthModal;
